import { trackException } from "@/appInsights";
import { AppNotification } from "@/constants/appNotification";
import { getMimeType } from "@/utils/blob";

function openBlobInNewTab(blob) {
  const blobURL = URL.createObjectURL(blob);
  const popup = window.open(blobURL);
  if (!popup) {
    URL.revokeObjectURL(blobURL);
    return;
  }

  const revokeBlobUrl = () => {
    URL.revokeObjectURL(blobURL);
  };

  popup.addEventListener("load", revokeBlobUrl, { once: true });
  popup.addEventListener("beforeunload", revokeBlobUrl, { once: true });
}

export async function handleDocumentPreview(
  url,
  extensionType,
  blob,
  errorCallback
) {
  if (blob) {
    openBlobInNewTab(blob);
    return blob;
  }

  try {
    const response = await fetch(url);
    const blobResult = await response.blob();

    const documentBlob = new Blob([blobResult], {
      type: getMimeType(extensionType)
    });

    openBlobInNewTab(documentBlob);

    return documentBlob;
  } catch (error) {
    trackException({
      exception: error,
      properties: {
        source: "component/IdentificationAdditionalDocuments/handleDocumentPreview"
      }
    });
    errorCallback({
      id: AppNotification.FailedToProcessDocument,
      titleKey: "additional_documents.failedToProcess",
      message: error.message
    });
  }
}
